import { atom } from 'jotai'
import { PaymentLinkStep } from 'types/payments'

export const paymentLinkStepAtom = atom<PaymentLinkStep>(PaymentLinkStep.CONTACT)
paymentLinkStepAtom.debugLabel = 'payment-link-step'

export const paymentLinkUrlAtom = atom('')
paymentLinkUrlAtom.debugLabel = 'payment-link-url'
